import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

export default function Sidebar({ activeItem }) {
  let loginUser = JSON.parse(localStorage.getItem("user"));
  let [loginUserType, setLoginUserType] = useState(loginUser?.user_type);

  let addBodyClass = () => {
    let w = window.innerWidth;
    if (w < 1200) {
      document?.body?.classList?.toggle("resize-menu");
    }
  };

  let onClickaddBodyClass = () => {
    let w = window.innerWidth;
    if (w < 1200) {
      document?.body?.classList?.toggle("resize-menu");
      return;
    }
    document.body.classList.add("resize-menu");
  };

  const location = useLocation();
  const [activeSubMenus, setActiveSubMenus] = useState({});

  const menuItems = [
    {
      id: "dashboard",
      title: "Dashboard",
      icon: "fa fa-tachometer", // FA4 equivalent of 'gauge'
      path: "/",
      hasSubmenu: false,
    },
    {
      type: "separator",
      id: "master-separator",
      title: "Master",
    },
    {
      id: "library",
      title: "My Library",
      icon: "fa fa-book", // FA4 library/book icon
      path: "/library",
      hasSubmenu: false,
    },
    // {
    //   id: "librarySlots",
    //   title: "Library Slots",
    //   icon: "fa fa-clock-o",
    //   path: "/slots",
    //   hasSubmenu: false,
    // },
    {
      id: "librarySlots",
      title: "Library Slots",
      icon: "fa fa-clock-o",
      path: "/slots",
      hasSubmenu: false,
    },
    {
      id: "libraryBookings",
      title: "Bookings",
      icon: "fa fa-calendar", // More intuitive for bookings
      path: "/orders/library-bookings",
      hasSubmenu: false,
    },
    {
      id: "paymentReport",
      title: "Payment Report",
      icon: "fa fa-file-text", // Report/document icon
      path: "/orders/payment-report",
      hasSubmenu: false,
    },
    {
      id: "referrals",
      title: "Referrals",
      icon: "fa fa-file-text", // Report/document icon
      path: "/referrals",
      hasSubmenu: false,
    },
    {
      id: "budget",
      title: "Budget",
      icon: "fa fa-dollar",
      path: "/budget",
      hasSubmenu: false,
    },
  ];


  useEffect(() => {
    // Initialize submenu states based on current path
    const subMenuStates = {};

    // Check all menu items with submenus
    menuItems.forEach((item) => {
      if (item.hasSubmenu && item.submenuItems) {
        // Check if current path matches any submenu item path
        const isActive = item.submenuItems.some(
          (subItem) => location.pathname === subItem.path
        );

        if (isActive) {
          subMenuStates[item.id] = true;
        }
      }
    });

    setActiveSubMenus(subMenuStates);
  }, [location.pathname]);

  const handleToggleSubmenu = (menuKey) => {
    setActiveSubMenus((prev) => ({
      ...prev,
      [menuKey]: !prev[menuKey],
    }));
  };

  // Check if a menu item or its submenu is active
  const isMenuActive = (item) => {
    if (!item.hasSubmenu) {
      return location.pathname === item.path;
    }

    return item.submenuItems.some(
      (subItem) => location.pathname === subItem.path
    );
  };

  return (
    <>
      <div className="dash-menu">
        <div className="dashbord-logo">
          <Link to="" className="navbar-brand d-flex align-items-center gap-2">
            <img src="/pi_logo.png" alt="" style={{ width: '50px', height: '50px' }} />
            <h2 className="text-white fw-bold" style={{ fontSize: '1.6rem' }}>PIDIGIHUB</h2>
          </Link>
          <Link
            className="toggle cross-icon"
            onClick={onClickaddBodyClass}
          >
            <i className="fa fa-chevron-left" />
          </Link>
        </div>
        <div className="dash-menu-bar">
          <nav className="nav-menu navbar navbar-expand-lg" id="navbar">
            <ul>
              {menuItems.map((item) => {
                // Render separator
                if (item.type === "separator") {
                  return (
                    <li
                      key={item.id}
                      className="menu-header"
                      style={{
                        fontSize: "13px",
                        padding: "10px 0px",
                      }}
                    >
                      {item.title}
                    </li>
                  );
                }

                // Render regular menu item
                return (
                  <li
                    key={item.id}
                    className={`nav-item ${item.hasSubmenu ? "has-submenu" : ""
                      } ${item.hasSubmenu && activeSubMenus[item.id] ? "show" : ""
                      }`}
                    onClick={item.hasSubmenu ? undefined : addBodyClass}
                  >
                    {item.hasSubmenu ? (
                      // Render menu item with submenu
                      <>
                        <div
                          className={`nav-link ${isMenuActive(item) ? "active" : ""
                            }`}
                          onClick={() => handleToggleSubmenu(item.id)}
                        >
                          <span className={`fa ${item.icon} me-2 icon`} />{" "}
                          {item.title}
                          <span className="d-inline-block ms-auto">
                            <i
                              className={`fa fa-angle-${activeSubMenus[item.id] ? "up" : "down"
                                } nav-link-arrow`}
                            />
                          </span>
                        </div>

                        {activeSubMenus[item.id] && (
                          <ul className="sub_menu">
                            {item.submenuItems.map((subItem) => (
                              <li
                                key={subItem.id}
                                className={`nav-item ${location.pathname === subItem.path
                                  ? "active"
                                  : ""
                                  }`}
                              >
                                <NavLink
                                  to={subItem.path}
                                  className="submenu-link"
                                  onClick={addBodyClass}
                                >
                                  <span
                                    className={`fa ${subItem.icon} me-2 icon`}
                                  />{" "}
                                  {subItem.title}
                                </NavLink>
                              </li>
                            ))}
                          </ul>
                        )}
                      </>
                    ) : (
                      <NavLink
                        to={item.path}
                        className={({ isActive }) =>
                          isActive ? "nav-link active" : "nav-link"
                        }
                      >
                        <span className={`fa ${item.icon} me-2 icon`} />
                        {item.title}
                      </NavLink>
                    )}
                  </li>
                );
              })}
            </ul>
          </nav>
        </div>
      </div>

      {/* CSS for submenus */}
      <style jsx="true">{`
        .dash-menu .nav-menu .nav-item.has-submenu .nav-link {
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
        }

        .dash-menu .nav-menu .nav-item.has-submenu.show .nav-link {
          background-color: #fff;
          color: #2d3748;
          box-shadow: 0px 3.5px 5.5px 0px #00000005;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
        }

        .dash-menu .nav-menu .nav-item.has-submenu.show .nav-link span.icon {
          background-color: #111727;
          color: #fff;
        }

        .sub_menu {
          background-color: #fff;
          color: #2d3748;
          padding: 0;
          margin: 0;
          margin-bottom: 10px;
          border-bottom-left-radius: 15px;
          border-bottom-right-radius: 15px;
          overflow: hidden;
          box-shadow: 0px 3.5px 5.5px 0px #00000005;
        }

        .sub_menu .nav-item {
          margin-bottom: 0;
          padding: 10px 15px;
          overflow: hidden;
        }

        .sub_menu .nav-item.active {
          background-color: #FF693D;
          border: 1px solid #fff;
          border-radius: inherit;
          box-shadow: 1px 2px 6px #ccc;
          margin-bottom: 0;
        }

        .sub_menu .nav-item .submenu-link {
          display: flex;
          align-items: center;
          color: #2d3748;
          font-size: 14px;
          font-weight: 500;
          text-transform: uppercase;
        }

        .sub_menu .nav-item.active .submenu-link {
          color: #fff;
        }

        .sub_menu .nav-item .submenu-link span.icon {
          display: inline-block;
          height: 30px;
          width: 30px;
          line-height: 30px;
          text-align: center;
          background-color: #111727;
          color: #fff;
          border-radius: 10px;
          margin-right: 8px;
        }

        .sub_menu .nav-item.active .submenu-link span.icon {
          background-color: #fff;
          color: #111727;
        }
        .sub_menu .nav-item:hover {
          background: #FFBD0C;
        }

        .menu-header{
        color: #fff;
  border-bottom: 1px dashed #E2EBEC;
  font-family:"poppins"
  padding-bottom:5px;
  margin-bottom:5px;
        }
      `}</style>
    </>
  );
}
